export default "__VITE_ASSET__dJGrPfPn__"